<template>
  <div id="disSales" class="px-2 pt-2">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
      style="z-index: 999999999"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <search-bar @onSearch="searchByName($event)" />
    <v-virtual-scroll
      :items="items"
      :item-height="230"
      id="distributorList"
      class="mt-5"
    >
      <template v-slot:default="{ item, index }">
        <v-card
          outlined
          tile
          height="100%"
          class="disInfo"
          :style="{
            'border-left-color': colors[index % 10],
          }"
        >
          <v-card-text style="height: 100%" class="pa-0 px-2">
            <v-row class="ma-0" style="height: 100%">
              <v-col cols="11" class="pa-0">
                <v-list class="transparent">
                  <v-list-item class="px-0">
                    <v-list-item-title> 合作时间 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.actualCooperationDate }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 合作进展 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item?.developmentState?.name ?? '' }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 经销商编号 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.code }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 经销商名称 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.name }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 负责人电话 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.tel }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 全年(12个月)所有品牌壁挂炉采购潜力(台) </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item?.ovenSaleCapacity ?? 0 }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 博世壁挂炉钱包份额SoW/% </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ (item?.sowValue ?? 0) * 100 }}%
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 预计当年博世壁挂炉采购贡献(台) </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item?.boschOvenSaleCapacity ?? 0 }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="1" class="pa-0 toDetail">
                <v-btn icon link :to="`/distributor/detail/${item.id}`">
                  <v-icon large>mdi-chevron-right</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </v-virtual-scroll>
    <v-row class="ma-0 pt-2">
      <v-spacer></v-spacer>
      <v-btn
        outlined
        tile
        class="success white--text mr-2"
        v-if="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')"
        @click="redirectToAdd"
        >新增</v-btn
      >
      <v-btn
        outlined
        tile
        class="primary white--text mr-2"
        v-if="user.role?.includes('RRS')"
        @click="dialog = true"
        >导入</v-btn
      >
      <v-btn
        outlined
        tile
        class="primary white--text"
        v-if="!user.role?.includes('Sales')"
        @click="exportDealer"
        >导出</v-btn
      >
    </v-row>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">导入</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form class="px-4 pt-2" ref="form" lazy-validation>
            <v-file-input
              truncate-length="15"
              v-model="fileToImport"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="save"> 保存 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading" style="z-index: 99999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SearchBar from "../../components/SearchBar.vue";
import api from "../../api/api";
export default {
  name: "DistributorForSales",
  components: {
    SearchBar,
  },
  data: () => ({
    message: {
      show: false,
      type: "success",
      text: "",
    },
    loading: false,
    items: [],
    colors: [
      "#D42027",
      "#8E2E62",
      "#893680",
      "#573B8E",
      "#2C3D7D",
      "#322C6F",
      "#089AD3",
      "#04b2d9",
      "#599956",
      "#87b957",
    ],
    payload: {
      region: null,
      province: null,
      city: null,
      salesId: null,
      year: null,
      name: null,
      dealerType: null,
      developmentStatus: null,
      signature: null,
    },
    dialog: false,
    fileToImport: null,
  }),
  computed: {
    ...mapState(["category", "user"]),
    isAdmin() {
      return this.user.role?.includes('HOD') || this.user.role?.includes('RRS') || this.user.role?.includes('SCN');
    },
  },
  created() {
    this.payload.region = this.$route.query.region || "";
    this.payload.province = this.$route.query.province || "";
    this.payload.city = this.$route.query.city || "";
    this.payload.salesId = this.$route.query.salesId || "";
    this.payload.year = this.$route.query.year || "";
    this.payload.dealerType = this.$route.query.dealerType || "";
    this.payload.developmentStatus = this.$route.query.developmentStatus || "";
    this.payload.signatured = this.$route.query.signatured || "";
    this.getDisData("");
  },
  methods: {
    searchByName($event) {
      this.payload.name = $event;
      this.getDisData($event);
    },
    async getDisData(name) {
      this.loading = true;
      let userId = "";
      let region = ""
      if (this.user.role?.includes('Sales') || this.user.role?.includes('Sell-in Sales')) {
        userId = this.user.userId;
      }
      if (this.user.role?.includes('RM')) {
        userId = '';
        region = this.user.userRegionCode;
      }
      if (this.user.role?.includes('RRS') || this.user.role?.includes('HOD')) {
        userId = '';
        region = '';
      }
      let salesId = this.$route.query.salesId || userId;
      if (this.user.role?.includes('External Sales')) {
        salesId = '';
      }
      api.dealer
        .getDealerList(
          `/dealer?name=${name}&region=${
            this.$route.query.region || region
          }&province=${this.$route.query.province || ""}&city=${
            this.$route.query.city || ""
          }&salesId=${salesId}&year=${
            this.$route.query.year || ""
          }&dealerType=${
            this.$route.query.dealerType || ""
          }&pageIndex=0&pageSize=50&developmentStatus=${
            this.$route.query.developmentStatus || ""
          }&signatured=${
            this.$route.query.signatured || ""
          }`
        )
        .then((res) => {
          const { data, status } = res?.data || {};
          console.log(data);
          if (status == 200 && data) {
            this.items = data.list.map((item) => {
              let majorSaleChannel = "";
              const majorSaleChannelIds = item.majorSaleChannelIds?.split(",");
              if (majorSaleChannelIds?.length) {
                majorSaleChannel = majorSaleChannelIds
                  .map((i) => {
                    const majorSaleChannel = this.category.filter(
                      (c) => c.id == i && c.categoryType == "xsqd"
                    );
                    if (majorSaleChannel.length) {
                      return majorSaleChannel[0].name;
                    } else {
                      return null;
                    }
                  })
                  .filter((i) => !!i)
                  .join(",");
              }
              return {
                ...item,
                addDate: item?.addDate?.slice(0, 7),
                majorSaleChannel,
              };
            });
          } else if (status == 200 && !data) {
            this.items = [];
            this.message = {
              show: true,
              type: "info",
              text: "没有数据！",
            };
          } else {
            this.items = [];
            this.message = {
              show: true,
              type: "info",
              text: "没有数据！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 600000);
        });
    },
    redirectToAdd() {
      this.$router.push({
        path: "/distributor/detail/0",
      });
    },
    exportDealer() {
      this.loading = true;
      this.payload.name = this.payload.name || "";
      api.dealer
        .exportDealer(this.payload)
        .then((res) => {
          if (
            res.data.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(res.data);
            link.download = "经销商清单";
            link.click();
          } else {
            alert("导出失败，请重试！");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      if (!this.fileToImport) {
        this.message = {
          show: true,
          type: "info",
          text: "请上传文档！",
        };
        setTimeout(() => {
          this.message.show = false;
        }, 600000);
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", this.fileToImport, this.fileToImport.name);
      api.dealer
        .importDealer(formData)
        .then((res) => {
          if (
            res.data.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(res.data);
            link.download = `导入结果`;
            link.click();
            this.fileToImport = null;
            this.dialog = false;
          } else {
            alert("导入失败，请重试！");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="sass">
#disSales
  height: calc(var(--vh, 1vh) * 100 - 48px)
  width: 100%
  #distributorList
    height: calc( 100% - 105px )
    .toDetail
      display: grid
      place-self: center
    .disInfo
      border-left-width: 5px
      border-left-style: solid
      .v-list-item
        min-height: 25px
        .v-list-item__title
          overflow: visible
        .v-list-item__subtitle
          overflow: visible
</style>
